import * as types from './actionTypes'
import { contactsService } from '../_services'

export function fetchContacts() {
    return dispatch => {
        return contactsService
            .getContacts()
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_CONTACTS, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_CONTACTS_FAILURE, error }
    }
}

export function updateContact(data) {
    return function(dispatch) {
        return contactsService
            .updateContact(data)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_CONTACTS, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_CONTACTS_FAILURE, error }
    }
}

export function addContact(data) {
    return function(dispatch) {
        return contactsService
            .addContact(data)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_CONTACTS, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_CONTACTS_FAILURE, error }
    }
}

export function removeContactById(id) {
    return function(dispatch) {
        return contactsService
            .removeContactById(id)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.REMOVE_CONTACT, payload: payload }
    }
    function failure(error) {
        return { type: types.REMOVE_CONTACT_FAILURE, error }
    }
}
